import { render } from "./vsaleuseradd.vue?vue&type=template&id=133c15e6&scoped=true"
import script from "./vsaleuseradd.vue?vue&type=script&lang=js"
export * from "./vsaleuseradd.vue?vue&type=script&lang=js"

import "./vsaleuseradd.vue?vue&type=style&index=0&id=133c15e6&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境租户后台rent.syinba.com/jsvueweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-133c15e6"]])

export default __exports__